import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import { InvestorSelectField, InvestorSelectFieldProps } from './InvestorSelectField';
import { AddressBookIcon } from '../../../icons/icons';
import { colourGrey08 } from '../../../styling/design/colours';
import { InvestorSearchModal } from '../../search/InvestorSearchModal';
import { InputOrSelectOverlaidActionIcon } from '../../../infrastructure/interface/forms/InputOrSelectOverlaidActionIcon';

type Props = Omit<InvestorSelectFieldProps, 'dropdownIcon'>;

export const InvestorSelectFieldWithSearchModal = (props: Props) => {
  const formikContext = useFormikContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onSelectCounterpartId = (counterpartId: number) => {
    formikContext.setFieldValue('investorId', (counterpartId === 0) ? null : counterpartId);
    setIsModalOpen(false);
  };

  return (
    <>
      <InputOrSelectOverlaidActionIcon
        icon={<AddressBookIcon />}
        onClickIcon={() => setIsModalOpen(true)}
        iconColour={colourGrey08}
      >
        <InvestorSelectField {...props} dropdownIcon={{ icon: <div /> }} />
      </InputOrSelectOverlaidActionIcon>
      {isModalOpen && (
        <InvestorSearchModal
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          onSelectCounterpartId={onSelectCounterpartId}
        />
      )}
    </>
  );
};
